import { render, staticRenderFns } from "./ElementsPreloader.vue?vue&type=template&id=54fa14c4&scoped=true&"
import script from "./ElementsPreloader.vue?vue&type=script&lang=js&"
export * from "./ElementsPreloader.vue?vue&type=script&lang=js&"
import style0 from "./ElementsPreloader.vue?vue&type=style&index=0&id=54fa14c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa14c4",
  null
  
)

export default component.exports